// src/components/constants/ExpertiseOptions.js

export const expertiseOptions = [
  // Frontend Development
  "React",
  "Angular",
  "Vue.js",
  "HTML",
  "CSS",
  "JavaScript",
  "Tailwind CSS",
  "Bootstrap",

  // Backend Development
  "Node.js",
  "Express.js",
  "Java",
  "Spring Boot",
  "Python",
  "Django",
  "Flask",
  "PHP",
  "Ruby on Rails",

  // Mobile Development
  "React Native",
  "Flutter",
  "Kotlin",
  "Swift",
  "Android",
  "iOS",

  // Data & AI
  "Machine Learning",
  "Deep Learning",
  "Data Science",
  "Artificial Intelligence",
  "Pandas",
  "NumPy",
  "TensorFlow",
  "PyTorch",
  "R Programming",

  // Cloud & DevOps
  "AWS",
  "Azure",
  "Google Cloud",
  "Docker",
  "Kubernetes",
  "CI/CD",
  "Terraform",

  // Cybersecurity
  "Network Security",
  "Ethical Hacking",
  "Penetration Testing",
  "Cryptography",

  // Databases
  "MySQL",
  "PostgreSQL",
  "MongoDB",
  "Firebase",
  "Oracle DB",
  "Redis",

  // UI/UX & Design
  "UI Design",
  "UX Design",
  "Figma",
  "Adobe XD",
  "Sketch",
  "Wireframing",
  "Prototyping",

  // Other Technical Skills
  "Data Structures & Algorithms",
  "System Design",
  "API Development",
  "WebSockets",
  "GraphQL",
];
